export const EduData = [
  {
    date: "July 2018 - July 2022",
    heading: "Bachelor Of Technology",
    subHeading: "St. Francis Institute Of Technology",
    extra: ["Electronics and Telecommunications", "CGPA: 8.96"],
    id: "EducFirst",
  },
  {
    date: "June 2016 - June 2018",
    heading: "HSC",
    subHeading: "Vidyanidhi Junior College Of Science",
    extra: ["Percentage: 79.47%"],
    id: "EducTwo",
  },
  {
    date: "March 2007 - March 2016",
    heading: "SSC",
    subHeading: "Smt. Rajrani Malhotra Vidyalaya",
    extra: ["Percentage: 87.20%"],
    id: "EducThree",
  },
];

export const ExpData = [
  {
    date: "March 2026 - Present",
    heading: "Clevertap",
    subHeading: "Senior Backend Engineer",
    extra: [
      "Working with billions of events in event-driven architecture.",
      "Making customer acquisition easy.",
      "Tech stack: Java Springboot,Redis,MongoDB",
    ],
    id: "clevertap",
  },
  {
    date: "Feb 2025 - March 2026",
    heading: "Plumhq",
    subHeading: "SDE 2",
    extra: [
      "Worked on the backend side of the things to enhance the performance and the response time.",
      "Designed and architected an higly customisable and configurable filtering system.",
      "Tech stack: NodeJs,Java Springboot,docker,GCP",
    ],
    id: "plumhq",
  },
  {
    date: "June 2022 - Feb 2025",
    heading: "Juspay",
    subHeading: "SDE",
    extra: [
      "Contributed to backend development for seamless merchant on boarding via internal dashboard, optimizing efficiency.",
      "Increased efficiency by 40% through the implementation of a merchant- configurable animation control system, rebuilding the standard structure.",
      "Designed and architected an efficient popup creation framework in a pure functional language",
      "Utilized Jenkins for CI/CD pipeline configuration.",
      "Tech stack: Purescript,Javascript,Haskell,docker",
    ],
    id: "juspay",
  },
  {
    date: "Nov 2020 - Jan 2021",
    heading: "Umbrette",
    subHeading: "Full Stack Developer Intern",
    extra: [
      "Worked on a client facing application using react.js, business-facing application using Django and Implemented queries of SQL",
      "Added mail services using smtp protocol, Graphical visualization for various data using chart.js",
    ],
    id: "umbrette",
  },
  {
    date: "July 2020 - Sept 2020",
    heading: "Olcademy",
    subHeading: "Full Stack Intern",
    extra: [
      "Developed user-oriented visuals and features using frontend languages, including Html, css and Javascript.",
      "Took concepts and produced design mock ups and prototypes to strengthen designs.",
      "Enhance user experiences, improved site interactions which also included payment transactions by running php in backend.",
    ],
    id: "olcademy",
  },
  {
    date: "Aug 2020 - Nov 2020",
    heading: "3Folks Media ",
    subHeading: "Public Relations Intern",
    extra: [
      "Gained Information about the inner workings and aspects of the public relations field, PR strateries and it's execution in different plases.",
      "Performed research and market analysis activities",
    ],
    id: "3Floks Media",
  },
];

export const aboutMe =
  "Goal-oriented Web Developer with strong commitment to collaboration and solutions-oriented problem-solving. Use various web design software to develop cusomer-focused websites and designs. Committed to high standards of web design, user experience, usablity and speed for multiple types of end-users. Successful at maintaining customer satisfaction through effective customer support. Solution driven professional excelling in highly collaborative work environment, finding solutions to challenges and focused on customer-satisfaction. Proven experience develping consumer-focused web sites using HTML, CSS, JQuery, PHP and Javascript. Translating solutions into code and working across many differnt Apis, third-party integrations and databases.";
export const skillSet = [
  "Html",
  "Css",
  "Javascript",
  "Java",
  "Rust",
  "Jenkins",
  "Docker",
  "JQuery",
  "React.Js",
  "Python",
  "Django",
  "Github",
  "Git",
  "Data Structures & Algorithms",
  "Linux",
  "PHP",
  "Computer Networking",
  "Operating System",
  "SQL",
  "Purescript",
];
